import React from 'react'
import { Provider } from 'react-redux'
import { I18nextProvider } from 'react-i18next'
import { initi18n } from '../utils/i18n'
import store from '../store'

import '../assets/css/general.scss'

import Carts from './Carts'

const App = () =>
  <Provider store={store}>
    <I18nextProvider i18n={initi18n()}>
      <Carts />
    </I18nextProvider>
  </Provider>

export default App
